import { IsArray, IsBoolean, IsCreditCard, IsDate, IsDateString, IsDefined, IsEmail, IsEnum, IsInt, IsMilitaryTime, IsNumberString, IsOptional, IsPhoneNumber, IsString, IsUrl, Matches, Max, MaxDate, MaxLength, Min, MinDate, MinLength, ValidatorConstraint, isDecimal, registerDecorator } from "class-validator";
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : null === desc ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function MinString(minString, validationOptions) {
    const options = {
        ...validationOptions,
        context: {
            minString
        }
    };
    return (target, propertyName)=>{
        registerDecorator({
            name: 'minString',
            target: target.constructor,
            propertyName,
            constraints: [
                minString
            ],
            options,
            validator: {
                validate (value) {
                    return 'string' == typeof value && 'string' == typeof minString && value >= minString;
                },
                defaultMessage () {
                    return '$property must not be less than "$constraint1"';
                }
            }
        });
    };
}
function MaxString(maxString, validationOptions) {
    const options = {
        ...validationOptions,
        context: {
            maxString
        }
    };
    return (target, propertyName)=>{
        registerDecorator({
            name: 'maxString',
            target: target.constructor,
            propertyName,
            constraints: [
                maxString
            ],
            options,
            validator: {
                validate (value) {
                    return 'string' == typeof value && 'string' == typeof maxString && value <= maxString;
                },
                defaultMessage () {
                    return '$property must not be greater than "$constraint1"';
                }
            }
        });
    };
}
function IsNotEmpty(validationOptions) {
    const options = {
        ...validationOptions
    };
    return (target, propertyName)=>{
        registerDecorator({
            name: 'isNotEmpty',
            target: target.constructor,
            propertyName,
            constraints: [],
            options,
            validator: {
                validate (value) {
                    if ('string' == typeof value) return '' !== value.trim();
                    return null != value;
                },
                defaultMessage () {
                    return '$property is required';
                }
            }
        });
    };
}
function Range(...arguments_) {
    const [type, minValue, maxValue] = 3 === arguments_.length ? arguments_ : [
        typeof arguments_[0],
        ...arguments_
    ];
    const isDate = `${type}`.endsWith('DateTime');
    const minFunction = 'number' === type ? decorators_Min(+minValue) : isDate ? decorators_MinDate(new Date(minValue)) : MinString(`${minValue}`);
    const maxFunction = 'number' === type ? decorators_Max(+maxValue) : isDate ? decorators_MaxDate(new Date(maxValue)) : MaxString(`${maxValue}`);
    return (target, key)=>{
        minFunction(target, key);
        maxFunction(target, key);
    };
}
const decorators_IsDefined = ()=>IsDefined({
        context: {}
    });
const decorators_IsOptional = ()=>IsOptional({
        context: {}
    });
const decorators_IsBoolean = ()=>IsBoolean({
        context: {}
    });
const decorators_IsString = ()=>IsString({
        context: {}
    });
const decorators_IsDate = ()=>IsDate({
        context: {}
    });
const decorators_IsDateString = ()=>IsDateString({
        strict: true
    });
const IsTime = ()=>IsMilitaryTime({
        context: {}
    });
const decorators_IsInt = ()=>IsInt({
        context: {}
    });
const decorators_IsNumberString = (options)=>IsNumberString(options, {
        context: {
            ...options
        }
    });
function IsDecimal(options) {
    return (target, propertyName)=>{
        registerDecorator({
            target: target.constructor,
            propertyName,
            constraints: [
                options
            ],
            validator: IsDecimalConstraint
        });
    };
}
class IsDecimalConstraint {
    validate(value, validationArguments) {
        if ('number' == typeof value) return Number.isFinite(value);
        const options = validationArguments.constraints[0];
        return isDecimal(value, options);
    }
    defaultMessage() {
        return '$property must be a number or a decimal string';
    }
}
IsDecimalConstraint = _ts_decorate([
    ValidatorConstraint({
        async: false,
        name: 'isDecimal'
    })
], IsDecimalConstraint);
const decorators_Min = (min)=>Min(min, {
        context: {
            min
        }
    });
const decorators_Max = (max)=>Max(max, {
        context: {
            max
        }
    });
const decorators_MinDate = (minDate)=>MinDate(minDate, {
        context: {
            minDate
        }
    });
const decorators_MaxDate = (maxDate)=>MaxDate(maxDate, {
        context: {
            maxDate
        }
    });
const decorators_MinLength = (minLength)=>MinLength(minLength, {
        context: {
            minLength
        }
    });
const decorators_MaxLength = (maxLength)=>MaxLength(maxLength, {
        context: {
            maxLength
        }
    });
const IsValidPhoneNumber = (region)=>IsPhoneNumber(region, {
        context: {
            region
        }
    });
const RegularExpression = (regex, translationKey)=>Matches(new RegExp(regex), {
        context: {
            regex,
            translationKey
        }
    });
const decorators_IsEmail = (options)=>IsEmail(options, {
        context: {
            ...options
        }
    });
const decorators_IsCreditCard = ()=>IsCreditCard({
        context: {}
    });
const decorators_IsUrl = (options)=>IsUrl(options, {
        context: {
            ...options
        }
    });
const decorators_IsArray = ()=>IsArray({
        context: {}
    });
const decorators_IsEnum = (entity)=>IsEnum(entity, {
        context: {
            entity
        }
    });
export { decorators_IsArray as IsArray, decorators_IsBoolean as IsBoolean, decorators_IsCreditCard as IsCreditCard, decorators_IsDate as IsDate, decorators_IsDateString as IsDateString, IsDecimal, decorators_IsDefined as IsDefined, decorators_IsEmail as IsEmail, decorators_IsEnum as IsEnum, decorators_IsInt as IsInt, IsNotEmpty, decorators_IsNumberString as IsNumberString, decorators_IsOptional as IsOptional, decorators_IsString as IsString, IsTime, decorators_IsUrl as IsUrl, IsValidPhoneNumber, decorators_Max as Max, decorators_MaxDate as MaxDate, decorators_MaxLength as MaxLength, MaxString, decorators_Min as Min, decorators_MinDate as MinDate, decorators_MinLength as MinLength, MinString, Range, RegularExpression };
